import React from 'react'
import Element from './Element'
import {PageProvider} from '../PocketHitsShared/page-context';
import {PreferencesProvider} from '../PocketHitsShared/preferences-context';
import {state} from '../PocketHitsShared/state';

const {newsletterPreferences, newsletterPage} = state;

export default () => (
    <PageProvider {...newsletterPage}>
      <PreferencesProvider {...newsletterPreferences}>
        <Element />
      </PreferencesProvider>
    </PageProvider>
)
